import type { MovementGridRow } from "@/redistribution/models/MovementGridRow.ts";
import type { PurchaseOrder } from "@/redistribution/models/PurchaseOrder.ts";

interface TransferRow {
  sku: string;
  fromPo: string;
  toPo: string;
  qty: number;
  status: string;
}

interface DerivePendingTransfersOptions {
  movementRows: Pick<MovementGridRow, "sku" | "from" | "to" | "qty">[];
  updatedPOs: PurchaseOrder[];
  originalPOs: PurchaseOrder[];
}

export function derivePendingTransfers(
  options: DerivePendingTransfersOptions
): TransferRow[] {
  const recipientStatusByPo = new Map<string, string>();

  for (const po of options.originalPOs) {
    recipientStatusByPo.set(po.purchaseOrderNumber, po.purchaseOrderStatus);
  }
  for (const po of options.updatedPOs) {
    recipientStatusByPo.set(po.purchaseOrderNumber, po.purchaseOrderStatus);
  }

  return options.movementRows
    .map((row) => {
      const status = recipientStatusByPo.get(row.to) ?? "Unknown";
      return {
        sku: row.sku,
        fromPo: row.from,
        toPo: row.to,
        qty: row.qty,
        status,
      };
    })
    .filter((row) => isPendingOrInProgress(row.status));
}

function isPendingOrInProgress(status: string): boolean {
  const normalized = status.toLowerCase().replaceAll(/[^a-z]/g, "");
  return normalized.includes("pending") || normalized.includes("inprogress");
}
